import styled from 'styled-components'

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`

export const PageTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0;
`

export const MeetingRoomToolbarActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  justify-self: end;
  align-self: center;
  max-width: 100%;

  .btn {
    width: auto;
    white-space: nowrap;
    flex-shrink: 0;
  }
`
